// in app/providers.tsx
'use client'
import SessionProvider from '@/components/Session/session-provider'
import { ThemeProvider } from '@/components/theme-provider'
import { ConsentProvider } from '@/contexts/ConsentContext'
import { WebSocketProvider } from '@/providers/WebsocketProvider'

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <WebSocketProvider>
        <ConsentProvider>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            {children}
          </ThemeProvider>
        </ConsentProvider>
      </WebSocketProvider>
    </SessionProvider>
  )
}
